/**
 * 分时
 */
import Trend from '../trend';
import {LINE_TYPE} from '../setting.js';
import {mergeModelData} from '../../util/index.js';
const model = {
  singleAmount: {
    Type: Number
  },
  fiveAmount: {
    Type: Number
  }
};
export default class TrendFiveState extends Trend {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _drawMain() {
    const {
      left,
      top,
      width,
      height,
      bottom,
      right
    } = this.availArea;
    const {avg_px, last_px, singleAmount, fiveAmount, sealObj} = this.state.data;
    const {preClosePx, tradeStatus} = sealObj;
    const {avgLine: avgOption, lastLine: lastOption, gridentColor} = this.option.Trend;
    // 计算节点之间的间距
    let space = width / fiveAmount;
    const len = last_px.length;
    const step = width / 5;
    const {LINE, GRIDENT} = LINE_TYPE;
    let total;
    if (tradeStatus === 'START') {
      total = Math.ceil(len / singleAmount);
    } else {
      total = Math.ceil((len - 1) / singleAmount);
    }
    for (let i = 0; i < total; i++) {
      // 五日最后一天包含0930等开盘价，数据长度比singleAmount多1
      // 且隔日之间趋势线不连续，需与分时线区分绘制
      const amount = i * singleAmount;
      const leftX = i * step + left;
      const _lastPx = i === total - 1 ? last_px.slice(amount) : last_px.slice(amount, amount + singleAmount);
      const _avgPx = i === total - 1 ? avg_px.slice(amount) : avg_px.slice(amount, amount + singleAmount);
      this._drawLine(GRIDENT, _lastPx, leftX, bottom, lastOption.lineWidth, gridentColor);
      this._drawLine(LINE, _lastPx, leftX, bottom, lastOption.lineWidth, lastOption.color);
      this._drawLine(LINE, _avgPx, leftX , bottom, avgOption.lineWidth, avgOption.color);
    }
  }
  _drawGrid() {
    super._drawGrid();
    // 五日坐标包含垂直虚线
    const {
      left,
      top,
      width,
      bottom
    } = this.availArea;
    const dashAmount = 5;
    const {dashColor} = this.option.MainContext;
    for (let i = 1; i < dashAmount; i++) {
      const axisX = left + (width / dashAmount) * i;
      const p1 = {x: axisX, y: top};
      const p2 = {x: axisX, y: bottom};
      this._drawDash(p1, p2, 0.5, dashColor);
    }
  }
}
